import { TeamAccessDTO } from '../team/team-access.dto';

export class CannedResponseListDTO extends TeamAccessDTO {

    name: string;

    content: string;
    
}
